import RouteTemplate from 'ember-route-template';

import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import LinksTo from 'ember-route-state/components/links-to.gjs';
import { pageTitle } from 'ember-page-title';

import CButton from 'rise-ui/components/c-button.gjs';
import ClearButton from 'rise-ui/components/clear-button.gjs';
import TabPanel from 'rise-ui/components/tab-panel.gjs';
import TransitionTo from 'rise-ui/components/transition-to.gjs';
import UniqueIdEl from 'rise-ui/components/unique-id-el.gjs';
import fnx from 'rise-ui/helpers/fnx.js';
import string from 'rise-ui/helpers/string.js';

export default RouteTemplate(class AccountComponent extends Component {
  @service catalogSearches;
  @service timeSeriesQueries;

  // Returns link-to child route associated to given tab name
  getTabLink(tabName) {
    return [ 'account', { isQueryParams: true, values: { tab: tabName } } ];
  }

  @action onDeleteSavedSearch(search) {
    search && this.catalogSearches.delete(search);
  }

  @action onDeleteSavedQuery(query) {
    query && this.timeSeriesQueries.delete(query);
  }

  <template>
    {{pageTitle "My RISE Account"}}

    <h3 class="c-page-title qa-page-title">My RISE Account</h3>

    <TabPanel @selected={{@controller.tab}} @linkTo={{this.getTabLink}} as | tab |>

      <tab @name="profile" @title={{string "account-profile"}}>
        <div class="c-section">
          <p><CButton>Save Updates</CButton></p>
          <label>
            Name (Optional)
            <input type="text">
          </label><br>
          <fieldset>
            <legend>
              What type of organization do you represent?
              (optional): Select all that apply
            </legend>
            <ul>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Govt - Federal</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Govt - State</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Govt - Regional/Local</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Research Institution</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Academic Institution</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Private Sector</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Non-Govt - Organization</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Other</label>
                <input type="text" aria-label="Other Value">
              </UniqueIdEl>
            </ul>
          </fieldset>
          <fieldset>
            <legend>
              Which RISE data themes are you interested in?
              (optional): Select all that apply
            </legend>
            <ul>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Water Quantity</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Water Quality</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Flood Management</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Energy</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Air Quality</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Ecosystem - Land</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Ecosystem - Aquatic</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Social Systems</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Other</label>
                <input type="text" aria-label="Other Value">
              </UniqueIdEl>
            </ul>
          </fieldset>
          <fieldset>
            <legend>
              How will you use RISE Data? (optional): Select all that apply
            </legend>
            <ul>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Research</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Environmental Documentation</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Endangered Species consultation</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Vulnerability Assessment</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Adaptation Planning</label>
              </UniqueIdEl>
              <UniqueIdEl @tag="li" as | id |>
                <input type="checkbox" id={{id}}>
                <label for={{id}}>Other</label>
                <input type="text" aria-label="Other Value">
              </UniqueIdEl>
            </ul>
          </fieldset>
        </div>
      </tab>

      <tab @name="searches" @title={{string "account-searches"}}>
        <div class="c-section">
          <p><LinksTo @route="catalog" class="c-button">Add New</LinksTo></p>
          <ul>
            {{#each this.catalogSearches.searches as | catalogSearch |}}
              <li>
                {{catalogSearch.name}}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <TransitionTo @href={{catalogSearch.href}}>
                  {{~catalogSearch.href~}}
                </TransitionTo>
                <ClearButton @title="Delete Saved Search"
                  @action={{fnx this.onDeleteSavedSearch catalogSearch}}
                >
                  Delete Saved Search
                </ClearButton>
              </li>
            {{/each}}
          </ul>
        </div>
      </tab>

      <tab @name="queries" @title={{string "account-queries"}}>
        <div class="c-section">
          <p><LinksTo @route="time-series" class="c-button">Add New</LinksTo></p>
          <ul>
            {{#each this.timeSeriesQueries.queries as | timeSeriesQuery |}}
              <li>
                {{timeSeriesQuery.name}}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <TransitionTo @href={{timeSeriesQuery.href}}>
                  {{~timeSeriesQuery.href~}}
                </TransitionTo>
                <ClearButton @title="Delete Saved Query"
                  @action={{fnx this.onDeleteSavedQuery timeSeriesQuery}}
                >
                  Delete Saved Query
                </ClearButton>
              </li>
            {{/each}}
          </ul>
        </div>
      </tab>

      <tab @name="alerts" @title={{string "account-alerts"}}>
        <div class="c-section">
          <p><CButton>Add New</CButton></p>
          <ul>
            {{#each this.timeSeriesAlerts as | timeSeriesAlert |}}
              <li>
              Time Series Alert &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href={{timeSeriesAlert}}>Link</a>
              </li>
            {{/each}}
          </ul>
        </div>
      </tab>

    </TabPanel>

    {{outlet}}
  </template>
});
